import request from "@/utils/request";

// 微信登录
export function getUserInfo(data) {
  return request({
    url: "/api/Wechat/GetSnsUserInfo",
    method: "get",
    params: data,
  });
}
// 获取用户信息
export function GetStudentByOpenId(data) {
  return request({
    url: "/api/Students/GetStudentByOpenId",
    method: "post",
    data,
  });
}
// 根据身份证号获取用户信息
export function GetSutentById(data) {
  return request({
    url: "/api/Students/GetSutentById",
    method: "post",
    data,
  });
}
// 获取用户是否可以考试
export function GetGraduationByIdCard(data) {
  return request({
    url: "/api/VideoCourseGraduation/GetGraduationByIdCard",
    method: "post",
    data,
  });
}
// 上传签名
export function EditSignUrl(data) {
  return request({
    url: "/api/User/EditSignUrl",
    method: "post",
    data,
  });
}
// 获取单位列表
export function GetAllCompany(data) {
  return request({
    url: "/api/Company/GetAll",
    method: "post",
    data,
  });
}
// 新增用户
export function StudentsAdd(data) {
  return request({
    url: "/api/Students/Add",
    method: "post",
    data,
  });
}
// 编辑用户信息
export function StudentsEdit(data) {
  return request({
    url: "/api/Students/Edit",
    method: "post",
    data,
  });
}
// 员工类别
export function getStudentType(data) {
  return request({
    url: "/api/StudentType/GetAll",
    method: "post",
    data,
  });
}
// 用户信息完善对身份证号进行查重
export function CheckRepeat(data) {
  return request({
    url: "/api/Students/CheckRepeat",
    method: "post",
    data,
  });
}
// 培训menu
export function GetFuntree(data) {
  return request({
    url: "/api/SubjectsM/GetFuntree",
    method: "post",
    data,
  });
}
// 根据parentID获取培训menu
export function GetFunTree2(data) {
  return request({
    url: "/api/SubjectsM/GetFunTree2",
    method: "post",
    data,
  });
}
// 部门班组树
export function GetUnitTree(data) {
  return request({
    url: "/api/Unit/GetFunTree2",
    method: "post",
    data,
  });
}
// 获取题库ID
export function getQuesID(data) {
  return request({
    url: "/api/Ques/getQuesID",
    method: "post",
    data,
  });
}
// 课程目录
export function getVideoM(data) {
  return request({
    url: "/api/VideoM/GetPage",
    method: "post",
    data,
  });
}
// 获取模拟试卷
export function getSimulatePaper(data) {
  return request({
    url: "/api/ques/getSimulatePaper",
    method: "post",
    data,
  });
}
// 提交错题
export function SaveCuoTi(data) {
  return request({
    url: "/api/OnlyTestManage/SaveCuoTi",
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    data,
  });
}
// 交卷
export function OnlyTestUserSubmitSocre(data) {
  return request({
    url: "/api/OnlyTestManage/OnlyTestUserSubmitSocre",
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    data,
  });
}
// 请求答题结构
export function GetPlanBySubjectID(data) {
  return request({
    url: "/api/TestManage/GetPlanBySubjectID",
    method: "post",
    data,
  });
}

// 观看完视频课件进行保存次数
export function AddVideoHistory(data) {
  return request({
    url: "/api/OnlyTestManage/AddVideoHistory",
    method: "post",
    data,
  });
}
// 观看视频课件记录
export function VideoHistory(data) {
  return request({
    url: "/api/OnlyTestManage/VideoHistory",
    method: "post",
    data,
  });
}
// 保存学员观看视频的进度
export function AddVideoRecord(data) {
  return request({
    url: "/api/VideoM/AddVideoRecord",
    method: "post",
    data,
  });
}

// 获取所有题库
export function getAllQuesconect(data) {
  return request({
    url: "/api/quesconect/getAllList.json",
    method: "get",
    params: data,
  });
}

// 验证支付状态
export function checkPay(data) {
  return request({
    url: "/api/quesconect/checkPay.json",
    method: "post",
    data,
  });
}

// 更新用户信息
export function trainstudents(data) {
  return request({
    url: "/api/trainstudents/saveData.json",
    method: "post",
    data,
  });
}

// 交卷
export function SubmitSocre(data) {
  return request({
    url: "/api/trainsubmithistory/SubmitSocre.json",
    method: "post",
    data,
  });
}
// 练题分析走势图
export function getChart(data) {
  return request({
    url: " /api/trainsubmithistory/getDataList.json",
    method: "post",
    data,
  });
}
// 自定义考场列表
export function getSelfDataList(data) {
  return request({
    url: "/api/trainplan/getDataList.json",
    method: "post",
    data,
  });
}
// 自定义考场保存
export function saveSelfData(data) {
  return request({
    url: "/api/trainplan/saveData.json",
    method: "post",
    data,
  });
}

// 练习分析
export function getStudent(data) {
  return request({
    url: "/api/trainstudentsanalysis/getDataInfo.json",
    method: "get",
    params: data,
  });
}

// 保存练题次数
export function saveStudent(data) {
  return request({
    url: "/api/trainstudentsanalysis/saveData.json",
    method: "post",
    data,
  });
}

// 错题集
export function getCuoTiList(data) {
  return request({
    url: "/api/traincuotibiao/getCuoTiList.json",
    method: "post",
    data,
  });
}

// 错题详情
export function getCuoTiDetail(data) {
  return request({
    url: "/api/traincuotibiao/getDetail.json",
    method: "post",
    data,
  });
}

// 获取字典
export function getSysDictionary(data) {
  return request({
    url: "/api/sysDictionary/getAllList.json",
    method: "post",
    data,
  });
}

// 获取班级
export function getTrain(data) {
  return request({
    url: "/api/train/getAllList.json",
    method: "post",
    data,
  });
}

export function getTrainList(data) {
  return request({
    url: "/api/train/getAllList.json",
    method: "post",
    data,
  });
}
export function getAnalysisZx(data) {
  return request({
    url: "/api/trainsubmithistory/GetAnalysisZx.json",
    method: "post",
    data,
  });
}

// 平均成绩
export function getAnalysis(data) {
  return request({
    url: "/api/trainsubmithistory/GetAnalysis.json",
    method: "post",
    data,
  });
}

// 查询班组
export function GetTrainClass(data) {
  return request({
    url: "/api/Train/GetTrainClass",
    method: "post",
    data,
  });
}

// 理由pc部门管理的分页接口获取部门
export function GetBm(data) {
  return request({
    url: "/api/Unit/GetFuntree",
    method: "post",
    data,
  });
}